const itemFlags = { vegetarian: false, bio: false, spicy: false };

export const drinksData = {
    aperitifs: {
        title_fr: "APÉRITIFS",
        title_en: "APERITIVES",
        description_fr: "",
        description_en: "",
        content: [
            {
                name_fr: "PASTIS",
                name_en: "PASTIS",
                description_fr: "",
                description_en: "",
                subContent: [{ quantity: "2cl", price: 4.5 }],
                ...itemFlags,
            },
            {
                name_fr: "AMERICANO",
                name_en: "AMERICANO",
                description_fr: "",
                description_en: "",
                subContent: [{ quantity: "6cl", price: 9.0 }],
                ...itemFlags,
            },
            {
                name_fr: "KIR",
                name_en: "KIR",
                description_fr: "Cassis, pêche ou mûre",
                description_en: "Black currant, peach or blackberry",
                subContent: [{ quantity: "15cl", price: 7.0 }],
                ...itemFlags,
            },
            {
                name_fr: "KIR ROYAL",
                name_en: "KIR ROYAL",
                description_fr: "",
                description_en: "",
                subContent: [{ quantity: "12cl", price: 11.0 }],
                ...itemFlags,
            },
            {
                name_fr: "MARTINI",
                name_en: "MARTINI",
                description_fr: "Blanc, rouge ou dry",
                description_en: "White, red or dry",
                subContent: [{ quantity: "6cl", price: 7.5 }],
                ...itemFlags,
            },
            {
                name_fr: "CAMPARI",
                name_en: "CAMPARI",
                description_fr: "",
                description_en: "",
                subContent: [{ quantity: "4cl", price: 7.5 }],
                ...itemFlags,
            },
            {
                name_fr: "SUZE",
                name_en: "SUZE",
                description_fr: "",
                description_en: "",
                subContent: [{ quantity: "4cl", price: 6.0 }],
                ...itemFlags,
            },
        ],
    },

    bieres: {
        title_fr: "BIÈRES",
        title_en: "BEERS",
        description_fr:
            "Happy Hour : du mardi au vendredi 18h–20h.<br/>Jeudi Happy Day ! Happy Hour toute la soirée.",
        description_en:
            "Happy Hour: Tuesday to Friday 6pm–8pm.<br/>Thursday Happy Day ! Happy Hour all evening.",
        content: [
            {
                name_fr: "1664 BLONDE",
                name_en: "1664 BLONDE",
                description_fr: "Bière pression",
                description_en: "Draft beer",
                subContent: [
                    { quantity: "25cl", price: 4.5 },
                    { quantity: "50cl", price: 8.0 },
                    { quantity: "HH", price: 7.0 },
                ],
                ...itemFlags,
            },
            {
                name_fr: "IPA BROOKLYN",
                name_en: "IPA BROOKLYN",
                description_fr: "Bière pression",
                description_en: "Draft beer",
                subContent: [
                    { quantity: "25cl", price: 5.0 },
                    { quantity: "50cl", price: 8.0 },
                    { quantity: "HH", price: 7.0 },
                ],
                ...itemFlags,
            },
            {
                name_fr: "LA BÊTE TRIPLE",
                name_en: "LA BÊTE TRIPLE",
                description_fr: "Bière pression",
                description_en: "Draft beer",
                subContent: [
                    { quantity: "25cl", price: 5.0 },
                    { quantity: "50cl", price: 9.0 },
                    { quantity: "HH", price: 7.0 },
                ],
                ...itemFlags,
            },
            {
                name_fr: "PICON BIÈRE",
                name_en: "PICON BEER",
                description_fr: "Bière pression",
                description_en: "Draft beer",
                subContent: [
                    { quantity: "25cl", price: 5.5 },
                    { quantity: "50cl", price: 9.0 },
                    { quantity: "HH", price: 7.0 },
                ],
                ...itemFlags,
            },
            {
                name_fr: "MONACO",
                name_en: "MONACO",
                description_fr: "Bière pression",
                description_en: "Draft beer",
                subContent: [
                    { quantity: "25cl", price: 5.5 },
                    { quantity: "50cl", price: 8.0 },
                    { quantity: "HH", price: 7.0 },
                ],
                ...itemFlags,
            },
            {
                name_fr: "BIÈRES BOUTEILLE",
                name_en: "BOTTLE BEERS",
                description_fr: "",
                description_en: "",
                subContent: [],
                ...itemFlags,
            },
            {
                name_fr: "1664 BLANCHE",
                name_en: "1664 BLANCHE",
                description_fr: "",
                description_en: "",
                subContent: [{ quantity: "33cl", price: 7.0 }],
                ...itemFlags,
            },
            {
                name_fr: "PERONI BLONDE",
                name_en: "PERONI BLONDE",
                description_fr: "",
                description_en: "",
                subContent: [{ quantity: "33cl", price: 7.0 }],
                ...itemFlags,
            },
            {
                name_fr: "1664 SANS ALCOOL",
                name_en: "1664 NON-ALCOHOLIC",
                description_fr: "",
                description_en: "",
                subContent: [{ quantity: "33cl", price: 7.0 }],
                ...itemFlags,
            },
        ],
    },

    whisky: {
        title_fr: "WHISKY",
        title_en: "WHISKY",
        description_fr: "",
        description_en: "",
        content: [
            {
                name_fr: "JACK DANIEL'S",
                name_en: "JACK DANIEL'S",
                description_fr: "",
                description_en: "",
                subContent: [{ quantity: "4cl", price: 9.0 }],
                ...itemFlags,
            },
            {
                name_fr: "GLENMORANGIE 12 ANS",
                name_en: "GLENMORANGIE 12 YEARS",
                description_fr: "Écosse",
                description_en: "Scotland",
                subContent: [{ quantity: "4cl", price: 12.0 }],
                ...itemFlags,
            },
            {
                name_fr: "MAKER'S MARK",
                name_en: "MAKER'S MARK",
                description_fr: "Kentucky Bourbon",
                description_en: "Kentucky Bourbon",
                subContent: [{ quantity: "4cl", price: 10.0 }],
                ...itemFlags,
            },
            {
                name_fr: "BUSHMILL'S",
                name_en: "BUSHMILL'S",
                description_fr: "Single Malt irlandais",
                description_en: "Irish Single Malt",
                subContent: [{ quantity: "4cl", price: 9.0 }],
                ...itemFlags,
            },
            {
                name_fr: "NIKKA",
                name_en: "NIKKA",
                description_fr: "Japon",
                description_en: "Japan",
                subContent: [{ quantity: "4cl", price: 12.0 }],
                ...itemFlags,
            },
            {
                name_fr: "TALISKER 10 ANS",
                name_en: "TALISKER 10 YEARS",
                description_fr: "Île de Skye",
                description_en: "Isle of Skye",
                subContent: [{ quantity: "4cl", price: 14.0 }],
                ...itemFlags,
            },
        ],
    },

    rhum: {
        title_fr: "RHUM",
        title_en: "RUM",
        description_fr: "",
        description_en: "",
        content: [
            {
                name_fr: "SANTA TERESA",
                name_en: "SANTA TERESA",
                description_fr: "Venezuela",
                description_en: "Venezuela",
                subContent: [{ quantity: "4cl", price: 11.0 }],
                ...itemFlags,
            },
            {
                name_fr: "RHUM BUMBU",
                name_en: "BUMBU RUM",
                description_fr: "La Barbade",
                description_en: "Barbados",
                subContent: [{ quantity: "4cl", price: 13.0 }],
                ...itemFlags,
            },
            {
                name_fr: "DIPLOMATICO",
                name_en: "DIPLOMATICO",
                description_fr: "",
                description_en: "",
                subContent: [{ quantity: "4cl", price: 10.0 }],
                ...itemFlags,
            },
            {
                name_fr: "DON PAPA",
                name_en: "DON PAPA",
                description_fr: "",
                description_en: "",
                subContent: [{ quantity: "4cl", price: 9.0 }],
                ...itemFlags,
            },
            {
                name_fr: "DUPPY SHARE SPICED",
                name_en: "DUPPY SHARE SPICED",
                description_fr: "",
                description_en: "",
                subContent: [{ quantity: "4cl", price: 12.0 }],
                ...itemFlags,
            },
            {
                name_fr: "EMINENTE RESERVA 7 ANS",
                name_en: "EMINENTE RESERVA 7 YEARS",
                description_fr: "",
                description_en: "",
                subContent: [{ quantity: "4cl", price: 13.0 }],
                ...itemFlags,
            },
            {
                name_fr: "ZACAPA 23",
                name_en: "ZACAPA 23",
                description_fr: "Guatemala",
                description_en: "Guatemala",
                subContent: [{ quantity: "4cl", price: 14.0 }],
                ...itemFlags,
            },
        ],
    },

    vodka: {
        title_fr: "VODKA",
        title_en: "VODKA",
        description_fr: "",
        description_en: "",
        content: [
            {
                name_fr: "GREY GOOSE",
                name_en: "GREY GOOSE",
                description_fr: "",
                description_en: "",
                subContent: [{ quantity: "4cl", price: 11.0 }],
                ...itemFlags,
            },
        ],
    },

    gin: {
        title_fr: "GIN",
        title_en: "GIN",
        description_fr: "",
        description_en: "",
        content: [
            {
                name_fr: "HENDRICK'S",
                name_en: "HENDRICK'S",
                description_fr: "Aux arômes de concombre",
                description_en: "With cucumber aromas",
                subContent: [{ quantity: "4cl", price: 11.0 }],
                ...itemFlags,
            },
            {
                name_fr: "YU GIN",
                name_en: "YU GIN",
                description_fr: "Ou équivalent. Aux arômes de citron Yuzu",
                description_en: "Or equivalent. With Yuzu lemon aromas",
                subContent: [{ quantity: "4cl", price: 12.0 }],
                ...itemFlags,
            },
            {
                name_fr: "GIN PINK",
                name_en: "GIN PINK",
                description_fr: "Aux arômes de rose et agrumes",
                description_en: "With rose and citrus aromas",
                subContent: [{ quantity: "4cl", price: 10.0 }],
                ...itemFlags,
            },
            {
                name_fr: "LIND & LIME MARITIME BIO",
                name_en: "LIND & LIME MARITIME BIO",
                description_fr: "Aux arômes poivrées",
                description_en: "With peppery aromas",
                subContent: [{ quantity: "4cl", price: 13.0 }],
                ...itemFlags,
            },
        ],
    },

    tequila: {
        title_fr: "TEQUILA",
        title_en: "TEQUILA",
        description_fr: "",
        description_en: "",
        content: [
            {
                name_fr: "TEQUILA PATRON",
                name_en: "TEQUILA PATRON",
                description_fr: "",
                description_en: "",
                subContent: [{ quantity: "4cl", price: 13.0 }],
                ...itemFlags,
            },
            {
                name_fr: "TEQUILA DON JULIO REPOSADO",
                name_en: "TEQUILA DON JULIO REPOSADO",
                description_fr: "",
                description_en: "",
                subContent: [{ quantity: "4cl", price: 11.0 }],
                ...itemFlags,
            },
        ],
    },

    spritz: {
        title_fr: "BAR À SPRITZ",
        title_en: "SPRITZ BAR",
        description_fr: "",
        description_en: "",
        content: [
            {
                name_fr: "LE ROYAL BASILIC SPRITZ",
                name_en: "ROYAL BASILIC SPRITZ",
                description_fr:
                    "Prosecco, liqueur Saint-Germain, basilic, purée de framboise, Ginger Ale",
                description_en:
                    "Prosecco, Saint-Germain liqueur, basil, raspberry purée, Ginger Ale",
                subContent: [{ quantity: null, price: 10 }],
                ...itemFlags,
            },
            {
                name_fr: "LE SECRET SPRITZ",
                name_en: "SECRET SPRITZ",
                description_fr: "Création spéciale du barman",
                description_en: "Bartender's special creation",
                subContent: [{ quantity: null, price: 10 }],
                ...itemFlags,
            },
            {
                name_fr: "LE OJS SPRITZ",
                name_en: "OJS SPRITZ",
                description_fr: "Prosecco, liqueur Saint-Germain, jus de pamplemousse",
                description_en: "Prosecco, Saint-Germain liqueur, grapefruit juice",
                subContent: [{ quantity: null, price: 10 }],
                ...itemFlags,
            },
            {
                name_fr: "LE QUEEN SPRITZ",
                name_en: "QUEEN SPRITZ",
                description_fr: "Vodka, Soho, Maracuja, purée de fruits rouges, Prosecco",
                description_en: "Vodka, Soho, maracuja, red fruit purée, Prosecco",
                subContent: [{ quantity: null, price: 10 }],
                ...itemFlags,
            },
            {
                name_fr: "LE LIMONCELLO SPRITZ",
                name_en: "LIMONCELLO SPRITZ",
                description_fr: "Prosecco, Limoncello, eau gazeuse",
                description_en: "Prosecco, limoncello, sparkling water",
                subContent: [{ quantity: null, price: 10 }],
                ...itemFlags,
            },
            {
                name_fr: "LE UGO SPRITZ",
                name_en: "UGO SPRITZ",
                description_fr: "Prosecco, liqueur de sureau, eau gazeuse",
                description_en: "Prosecco, elderflower liqueur, sparkling water",
                subContent: [{ quantity: null, price: 10 }],
                ...itemFlags,
            },
        ],
    },

    cocktails: {
        title_fr: "COCKTAILS",
        title_en: "COCKTAILS",
        description_fr:
            "Happy Hour : du mardi au vendredi 18h–20h.<br/>Jeudi Happy Day ! Happy Hour toute la soirée.",
        description_en:
            "Happy Hour: Tuesday to Friday 6pm–8pm.<br/>Thursday Happy Day ! Happy Hour all evening.",
        content: [
            {
                name_fr: "LE JACK ZUCCHERO",
                name_en: "JACK ZUCCHERO",
                description_fr:
                    "Jack Daniels, jus de pomme, jus de poire, crème de pêche, sirop de pêche",
                description_en:
                    "Jack Daniels, apple juice, pear juice, peach cream, peach syrup",
                subContent: [
                    { quantity: null, price: 10 },
                    { quantity: "HH", price: 8 },
                ],
                ...itemFlags,
            },
            {
                name_fr: "LE PASSIONATO",
                name_en: "PASSIONATO",
                description_fr:
                    "Rhum, jus de mangue, thé au jasmin, jus de maracuja et vanille",
                description_en: "Rum, mango juice, jasmine tea, maracuja juice and vanilla",
                subContent: [
                    { quantity: null, price: 10 },
                    { quantity: "HH", price: 8 },
                ],
                ...itemFlags,
            },
            {
                name_fr: "LE CHA MULE",
                name_en: "CHA MULE",
                description_fr:
                    "Chardonnay, crème de pêche, ginger beer, coulis de fruits rouges",
                description_en: "Chardonnay, peach liqueur, ginger beer, red fruit coulis",
                subContent: [
                    { quantity: null, price: 10 },
                    { quantity: "HH", price: 8 },
                ],
                ...itemFlags,
            },
            {
                name_fr: "LE LAISSE TOI FAIRE",
                name_en: "LAISSE TOI FAIRE",
                description_fr: "Création spéciale du barman",
                description_en: "Bartender's special creation",
                subContent: [
                    { quantity: null, price: 10 },
                    { quantity: "HH", price: 8 },
                ],
                ...itemFlags,
            },
            {
                name_fr: "LE CACTUS",
                name_en: "CACTUS",
                description_fr:
                    "Tequila, curaçao, sirop de citron, jus de mangue, jus d'ananas",
                description_en: "Tequila, curaçao, lemon syrup, mango juice, pineapple juice",
                subContent: [
                    { quantity: null, price: 10 },
                    { quantity: "HH", price: 8 },
                ],
                ...itemFlags,
            },
            {
                name_fr: "LE MELA PESCA",
                name_en: "MELA PESCA",
                description_fr:
                    "Gin, jus de pomme, sirop de pêche, jus de citron, menthe fraîche et jus de pêche",
                description_en:
                    "Gin, apple juice, peach syrup, lemon juice, fresh mint and peach juice",
                subContent: [
                    { quantity: null, price: 10 },
                    { quantity: "HH", price: 8 },
                ],
                ...itemFlags,
            },
            {
                name_fr: "LE ROMY",
                name_en: "ROMY",
                description_fr:
                    "Jus de citron, lait de coco, fruits rouges, liqueur Malibu, liqueur de Soho, vodka",
                description_en:
                    "Lemon juice, coconut milk, red fruits, Malibu liqueur, Soho liqueur, vodka",
                subContent: [
                    { quantity: null, price: 10 },
                    { quantity: "HH", price: 8 },
                ],
                ...itemFlags,
            },
            {
                name_fr: "LES CLASSIQUES",
                name_en: "CLASSICS",
                description_fr:
                    "Tous les classiques sont cachés dans la tête du barman... Il suffit de les demander !<br/>Mojito, Spritz, Sex on the beach, Blue Lagoon, Moscow Mule... et bien plus encore.",
                description_en:
                    "All the classics are tucked away in the bartender's head... Just ask!<br/>Mojito, Spritz, Sex on the Beach, Blue Lagoon, Moscow Mule... and much more.",
                subContent: [
                    { quantity: null, price: 10 },
                    { quantity: "HH", price: 8 },
                ],
                ...itemFlags,
            },
        ],
    },

    mocktails: {
        title_fr: "MOCKTAILS (SANS ALCOOL)",
        title_en: "MOCKTAILS (NON-ALCOHOLIC)",
        description_fr:
            "Happy Hour : du mardi au vendredi 18h–20h.<br/>Jeudi Happy Day ! Happy Hour toute la soirée.",
        description_en:
            "Happy Hour: Tuesday to Friday 6pm–8pm.<br/>Thursday Happy Day ! Happy Hour all evening.",
        content: [
            {
                name_fr: "LE VIRGIN MOJITO",
                name_en: "VIRGIN MOJITO",
                description_fr: "Citron, cassonade, menthe, Perrier",
                description_en: "Lime, brown sugar, mint, Perrier",
                subContent: [
                    { quantity: null, price: 7.9 },
                    { quantity: "HH", price: 6.0 },
                ],
                ...itemFlags,
            },
            {
                name_fr: "LE VIRGIN COLADA",
                name_en: "VIRGIN COLADA",
                description_fr: "Lait de coco, jus d'ananas",
                description_en: "Coconut milk, pineapple juice",
                subContent: [
                    { quantity: null, price: 7.9 },
                    { quantity: "HH", price: 6.0 },
                ],
                ...itemFlags,
            },
            {
                name_fr: "L'O SOLE MIO",
                name_en: "O SOLE MIO",
                description_fr: "Jus d'orange, jus d'abricot, limonade, sirop de grenadine",
                description_en: "Orange juice, apricot juice, lemonade, grenadine syrup",
                subContent: [
                    { quantity: null, price: 7.9 },
                    { quantity: "HH", price: 6.0 },
                ],
                ...itemFlags,
            },
            {
                name_fr: "LE CARAÏBES",
                name_en: "CARAÏBES",
                description_fr: "Jus de mangue, lait de coco, maracuja, purée de framboise",
                description_en: "Mango juice, coconut milk, maracuja, raspberry purée",
                subContent: [
                    { quantity: null, price: 7.9 },
                    { quantity: "HH", price: 6.0 },
                ],
                ...itemFlags,
            },
            {
                name_fr: "THÉ GLACÉ",
                name_en: "ICED TEA",
                description_fr: "Thé au jasmin, menthe, jus de pêche",
                description_en: "Jasmine tea, mint, peach juice",
                subContent: [
                    { quantity: null, price: 7.9 },
                    { quantity: "HH", price: 6.0 },
                ],
                ...itemFlags,
            },
            {
                name_fr: "LE DOLCE VITA",
                name_en: "DOLCE VITA",
                description_fr: "Jus de pamplemousse, cranberry, sirop de fraise",
                description_en: "Grapefruit juice, cranberry, strawberry syrup",
                subContent: [
                    { quantity: null, price: 7.9 },
                    { quantity: "HH", price: 6.0 },
                ],
                ...itemFlags,
            },
            {
                name_fr: "LES CLASSIQUES",
                name_en: "CLASSICS",
                description_fr:
                    "Tous les classiques sont cachés dans la tête du barman... Il suffit de les demander !",
                description_en:
                    "All the classics are tucked away in the bartender's head... Just ask!",
                subContent: [
                    { quantity: null, price: 7.9 },
                    { quantity: "HH", price: 6.0 },
                ],
                ...itemFlags,
            },
        ],
    },

    softs: {
        title_fr: "SOFTS",
        title_en: "SOFT DRINKS",
        description_fr: "",
        description_en: "",
        content: [
            {
                name_fr: "COCA / COCA ZERO",
                name_en: "COCA / COCA ZERO",
                description_fr: "",
                description_en: "",
                subContent: [{ quantity: "33cl", price: 4.9 }],
                ...itemFlags,
            },
            {
                name_fr: "LIMONADE",
                name_en: "LEMONADE",
                description_fr: "",
                description_en: "",
                subContent: [{ quantity: "25cl", price: 4.0 }],
                ...itemFlags,
            },
            {
                name_fr: "ORANGINA",
                name_en: "ORANGINA",
                description_fr: "",
                description_en: "",
                subContent: [{ quantity: "33cl", price: 4.5 }],
                ...itemFlags,
            },
            {
                name_fr: "GINGER BEER",
                name_en: "GINGER BEER",
                description_fr: "",
                description_en: "",
                subContent: [{ quantity: "25cl", price: 5.5 }],
                ...itemFlags,
            },
            {
                name_fr: "JUS DE FRUITS",
                name_en: "FRUIT JUICES",
                description_fr: "Pomme, orange, fraise, ...",
                description_en: "Apple, orange, strawberry, ...",
                subContent: [{ quantity: "25cl", price: 5.0 }],
                ...itemFlags,
            },
            {
                name_fr: "DIABOLO",
                name_en: "DIABOLO",
                description_fr: "",
                description_en: "",
                subContent: [{ quantity: "25cl", price: 5.0 }],
                ...itemFlags,
            },
            {
                name_fr: "PERRIER",
                name_en: "PERRIER",
                description_fr: "",
                description_en: "",
                subContent: [{ quantity: "33cl", price: 4.5 }],
                ...itemFlags,
            },
            {
                name_fr: "SAN BENEDETTO GAZEUSE",
                name_en: "SAN BENEDETTO SPARKLING",
                description_fr: "",
                description_en: "",
                subContent: [{ quantity: "100cl", price: 6.0 }],
                ...itemFlags,
            },
            {
                name_fr: "SAN BENEDETTO PLATE",
                name_en: "SAN BENEDETTO STILL",
                description_fr: "",
                description_en: "",
                subContent: [{ quantity: "100cl", price: 6.0 }],
                ...itemFlags,
            },
        ],
    },

    italianRedWine: {
        title_fr: "VINS ROUGES ITALIENS",
        title_en: "ITALIAN RED WINES",
        description_fr: "",
        description_en: "",
        content: [
            {
                name_fr: "MONTEPULCIANO JU ZIRÈ DOC",
                name_en: "MONTEPULCIANO JU ZIRÈ DOC",
                description_fr:
                    "Abruzzes - Structure tannique, arômes de cerise noire, prune et réglisse",
                description_en:
                    "Abruzzo - Tannic structure, aromas of black cherry, plum and licorice",
                subContent: [
                    { quantity: "15cl", price: 7.0 },
                    { quantity: "50cl", price: 23.0 },
                    { quantity: "75cl", price: 29.0 },
                ],
                ...itemFlags,
            },
            {
                name_fr: "NERO D'AVOLA MORANERA DOC",
                name_en: "NERO D'AVOLA MORANERA DOC",
                description_fr:
                    "Sicile - Fraîcheur agréable, structure douce, discrète et enveloppante",
                description_en:
                    "Sicily - Pleasant freshness, soft, discreet and enveloping structure",
                subContent: [
                    { quantity: "15cl", price: 6.0 },
                    { quantity: "50cl", price: 21.0 },
                    { quantity: "75cl", price: 28.0 },
                ],
                ...itemFlags,
            },
            {
                name_fr: "NEGROAMARO PRIMITIVO IGP",
                name_en: "NEGROAMARO PRIMITIVO IGP",
                description_fr:
                    "Les Pouilles - Arômes épicées, senteurs de romarin et de vanille",
                description_en:
                    "Puglia - Spicy aromas, hints of rosemary and vanilla",
                subContent: [
                    { quantity: "15cl", price: 8.0 },
                    { quantity: "50cl", price: 24.0 },
                    { quantity: "75cl", price: 31.0 },
                ],
                ...itemFlags,
            },
            {
                name_fr: "VALPOLICELLA CLASSICO DOC",
                name_en: "VALPOLICELLA CLASSICO DOC",
                description_fr: "Vénétie - Fruité, notes florales et de cerises",
                description_en: "Veneto - Fruity, floral notes and cherries",
                subContent: [
                    { quantity: "15cl", price: 6.5 },
                    { quantity: "50cl", price: 21.0 },
                    { quantity: "75cl", price: 29.0 },
                ],
                ...itemFlags,
            },
            {
                name_fr: "CHIANTI PETRIBONI DOC",
                name_en: "CHIANTI PETRIBONI DOC",
                description_fr:
                    "Toscane - Élégant, complexe et structuré aux arômes de fruits rouges",
                description_en:
                    "Tuscany - Elegant, complex and structured with red fruit aromas",
                subContent: [
                    { quantity: "75cl", price: 32.0 },
                ],
                ...itemFlags,
            },
            {
                name_fr: "BAROLO DOCG",
                name_en: "BAROLO DOCG",
                description_fr:
                    "Le Piémont - Charpenté, velouté épicé et aux arômes de caramel et fruits rouges",
                description_en:
                    "Piedmont - Full-bodied, spicy velvet with caramel and red fruit aromas",
                subContent: [{ quantity: "75cl", price: 75.0 }],
                ...itemFlags,
            },
            {
                name_fr: "AMARONE DELLA VALPOLICELLA CLASSICO DOC",
                name_en: "AMARONE DELLA VALPOLICELLA CLASSICO DOC",
                description_fr:
                    "Vénétie - Puissant, aux arômes de pruneaux, de tabac et d'épices",
                description_en:
                    "Veneto - Powerful, with aromas of prunes, tobacco and spices",
                subContent: [
                    { quantity: "75cl", price: 81.0 },
                ],
                ...itemFlags,
            },
        ],
    },

    frenchRedWine: {
        title_fr: "VINS ROUGES FRANÇAIS",
        title_en: "FRENCH RED WINES",
        description_fr: "",
        description_en: "",
        content: [
            {
                name_fr: "PINOT NOIR BOUCHARD VDF",
                name_en: "PINOT NOIR BOUCHARD VDF",
                description_fr:
                    "Bourgogne - Notes de mûres et framboises, léger en bouche",
                description_en:
                    "Burgundy - Notes of blackberries and raspberries, light on the palate",
                subContent: [
                    { quantity: "15cl", price: 6.5 },
                    { quantity: "50cl", price: 19.0 },
                    { quantity: "75cl", price: 29.0 },
                ],
                ...itemFlags,
            },
            {
                name_fr: "ALOXE CORTON MAISON BICHOT AOP",
                name_en: "ALOXE CORTON MAISON BICHOT AOP",
                description_fr:
                    "Bourgogne - Bouquet parfumé, notes de cerises et framboises, structure tannique souple",
                description_en:
                    "Burgundy - Fragrant bouquet, cherry and raspberry notes, supple tannic structure",
                subContent: [{ quantity: "75cl", price: 85.0 }],
                ...itemFlags,
            },
            {
                name_fr: "SAINT AMOUR MAISON LOUIS TÊTE AOP",
                name_en: "SAINT AMOUR MAISON LOUIS TÊTE AOP",
                description_fr:
                    "Beaujolais - Fraîcheur en bouche, souple et arômes de framboise et mûres",
                description_en:
                    "Beaujolais - Fresh on the palate, supple with raspberry and blackberry aromas",
                subContent: [{ quantity: "75cl", price: 35.0 }],
                ...itemFlags,
            },
            {
                name_fr: "PIC SAINT LOUP LES GARRIGUES AOP",
                name_en: "PIC SAINT LOUP LES GARRIGUES AOP",
                description_fr:
                    "Languedoc - Riche en bouche, tanin fin et durable en bouche",
                description_en:
                    "Languedoc - Rich on the palate, fine and lasting tannins",
                subContent: [{ quantity: "75cl", price: 37.0 }],
                ...itemFlags,
            },
            {
                name_fr: "CROZES HERMITAGE LE CLOS SERVIEN AOP",
                name_en: "CROZES HERMITAGE LE CLOS SERVIEN AOP",
                description_fr:
                    "Vallée du Rhône - Robe sombre, notes d'épices et de vanille, tanins soyeux et longs en bouche",
                description_en:
                    "Rhône Valley - Dark colour, spice and vanilla notes, silky long tannins",
                subContent: [{ quantity: "75cl", price: 55.0 }],
                ...itemFlags,
            },
            {
                name_fr: "SAINT JULIEN PAVILLON DU GLANA AOP",
                name_en: "SAINT JULIEN PAVILLON DU GLANA AOP",
                description_fr:
                    "Bordeaux - Second vin du château du Glana, robe rubis, notes de myrtilles, de vanille et d'épices très fines",
                description_en:
                    "Bordeaux - Second wine of Château du Glana, ruby colour, blueberry, vanilla and fine spice notes",
                subContent: [{ quantity: "75cl", price: 67.0 }],
                ...itemFlags,
            },
        ],
    },

    italianWhiteWine: {
        title_fr: "VINS BLANCS ITALIENS",
        title_en: "ITALIAN WHITE WINES",
        description_fr: "",
        description_en: "",
        content: [
            {
                name_fr: "PINOT GRIGIO IGT",
                name_en: "PINOT GRIGIO IGT",
                description_fr: "Vénétie - Équilibré, aux arômes de poire et de melon",
                description_en: "Veneto - Balanced, with pear and melon aromas",
                subContent: [
                    { quantity: "15cl", price: 6.5 },
                    { quantity: "50cl", price: 24.0 },
                    { quantity: "75cl", price: 29.0 },
                ],
                ...itemFlags,
            },
            {
                name_fr: "GRILLO DOC",
                name_en: "GRILLO DOC",
                description_fr: "Sicile - Élégant, minéral et sec",
                description_en: "Sicily - Elegant, mineral and dry",
                subContent: [
                    { quantity: "15cl", price: 7.5 },
                    { quantity: "50cl", price: 23.0 },
                    { quantity: "75cl", price: 32.0 },
                ],
                ...itemFlags,
            },
            {
                name_fr: "ZIBBIBO LIQUORIOSSO IGT",
                name_en: "ZIBBIBO LIQUORIOSSO IGT",
                description_fr: "Sicile - Liquoreux, aux arômes de fruits confits",
                description_en: "Sicily - Sweet wine, with candied fruit aromas",
                subContent: [
                    { quantity: "15cl", price: 9.0 },
                    { quantity: "50cl", price: 25.0 },
                    { quantity: "75cl", price: 38.0 },
                ],
                ...itemFlags,
            },
            {
                name_fr: "VERMENTINO DOC",
                name_en: "VERMENTINO DOC",
                description_fr: "Sardaigne - Arômes fruitées, agréable, belle fraîcheur",
                description_en: "Sardinia - Fruity aromas, pleasant, lovely freshness",
                subContent: [
                    { quantity: "75cl", price: 39.0 },
                ],
                ...itemFlags,
            },
        ],
    },

    frenchWhiteWine: {
        title_fr: "VINS BLANCS FRANÇAIS",
        title_en: "FRENCH WHITE WINES",
        description_fr: "",
        description_en: "",
        content: [
            {
                name_fr: "CHARDONNAY « CAPRICE » IGP",
                name_en: "CHARDONNAY « CAPRICE » IGP",
                description_fr: "Bourgogne - Fraîcheur en bouche, floral et notes d'agrumes",
                description_en: "Burgundy - Fresh on the palate, floral with citrus notes",
                subContent: [
                    { quantity: "15cl", price: 6.0 },
                    { quantity: "50cl", price: 19.0 },
                    { quantity: "75cl", price: 26.0 },
                ],
                ...itemFlags,
            },
            {
                name_fr: "MÂCON VILLAGES MAISON MANCEY AOP",
                name_en: "MÂCON VILLAGES MAISON MANCEY AOP",
                description_fr:
                    "Bourgogne - Robe or et clair, notes de pomme, abricot et coing, équilibré en bouche",
                description_en:
                    "Burgundy - Golden clear colour, apple, apricot and quince notes, balanced on the palate",
                subContent: [{ quantity: "75cl", price: 36.0 }],
                ...itemFlags,
            },
            {
                name_fr: "SANCERRE MAISON DURAND AOP",
                name_en: "SANCERRE MAISON DURAND AOP",
                description_fr:
                    "Loire - Nez frais en mentholé, notes d'agrumes et vif en bouche",
                description_en:
                    "Loire - Fresh menthol nose, citrus notes and lively on the palate",
                subContent: [{ quantity: "75cl", price: 42.0 }],
                ...itemFlags,
            },
            {
                name_fr: "CONTRIEU MAISON CASTEL AOP",
                name_en: "CONTRIEU MAISON CASTEL AOP",
                description_fr:
                    "Vallée du Rhône - Notes de verveine et de pêche blanche, beau volume en bouche et beaucoup de minéralité",
                description_en:
                    "Rhône Valley - Verbena and white peach notes, great volume and minerality",
                subContent: [{ quantity: "75cl", price: 72.0 }],
                ...itemFlags,
            },
        ],
    },

    italianRoseWine: {
        title_fr: "VINS ROSÉS ITALIENS",
        title_en: "ITALIAN ROSÉ WINES",
        description_fr: "",
        description_en: "",
        content: [
            {
                name_fr: "SANTA GIULIA IGP",
                name_en: "SANTA GIULIA IGP",
                description_fr: "Corse - Fruité, idéal pour un apéritif estival !",
                description_en: "Corsica - Fruity, ideal for a summer aperitif!",
                subContent: [
                    { quantity: "15cl", price: 6.5 },
                    { quantity: "50cl", price: 20.0 },
                    { quantity: "75cl", price: 27.0 },
                ],
                ...itemFlags,
            },
            {
                name_fr: "CHIARETTO DI BARDOLINO CLASSICO DOC",
                name_en: "CHIARETTO DI BARDOLINO CLASSICO DOC",
                description_fr:
                    "Vénétie - Rosé fruité et frais aux notes de fraise, pêche et fruits rouges",
                description_en:
                    "Veneto - Fruity and fresh rosé with strawberry, peach and red fruit notes",
                subContent: [
                    { quantity: "15cl", price: 6.5 },
                    { quantity: "50cl", price: 20.0 },
                    { quantity: "75cl", price: 26.0 },
                ],
                ...itemFlags,
            },
        ],
    },

    frenchRoseWine: {
        title_fr: "VINS ROSÉS FRANÇAIS",
        title_en: "FRENCH ROSÉ WINES",
        description_fr: "",
        description_en: "",
        content: [
            {
                name_fr: "ROUTE DES PLAGES IGP",
                name_en: "ROUTE DES PLAGES IGP",
                description_fr: "Méditerranée - Rosé gris, fraîcheur en bouche assurée",
                description_en: "Mediterranean - Grey rosé, guaranteed freshness on the palate",
                subContent: [
                    { quantity: "15cl", price: 6.0 },
                    { quantity: "50cl", price: 19.0 },
                    { quantity: "75cl", price: 25.0 },
                ],
                ...itemFlags,
            },
            {
                name_fr: "M DE MINUTY",
                name_en: "M DE MINUTY",
                description_fr:
                    "Provence, Côtes de Provence AOP - Rosé élégant et frais, aux arômes de pêche blanche, agrumes et fruits rouges",
                description_en:
                    "Provence, Côtes de Provence AOP - Elegant and fresh rosé with white peach, citrus and red fruit aromas",
                subContent: [
                    { quantity: "15cl", price: 7.9 },
                    { quantity: "50cl", price: 27.0 },
                    { quantity: "75cl", price: 36.0 },
                ],
                ...itemFlags,
            },
        ],
    },

    sparklingWine: {
        title_fr: "VINS PÉTILLANTS",
        title_en: "SPARKLING WINES",
        description_fr: "",
        description_en: "",
        content: [
            {
                name_fr: "PROSECCO EDOARDO ROTA",
                name_en: "PROSECCO EDOARDO ROTA",
                description_fr: "La bulle italienne dans toute sa splendeur !",
                description_en: "Italian bubbles in all their splendour!",
                subContent: [
                    { quantity: "15cl", price: 7.0 },
                    { quantity: "75cl", price: 36.0 },
                ],
                ...itemFlags,
            },
            {
                name_fr: "LAMBRUSCO",
                name_en: "LAMBRUSCO",
                description_fr:
                    "Rouge effervescent aux arômes de fraise, léger et désaltérant",
                description_en:
                    "Sparkling red with strawberry aromas, light and refreshing",
                subContent: [{ quantity: "75cl", price: 32.0 }],
                ...itemFlags,
            },
        ],
    },

    champagne: {
        title_fr: "CHAMPAGNE",
        title_en: "CHAMPAGNE",
        description_fr: "",
        description_en: "",
        content: [
            {
                name_fr: "ROGER GUY BRUT",
                name_en: "ROGER GUY BRUT",
                description_fr: "",
                description_en: "",
                subContent: [
                    { quantity: "15cl", price: 9.0 },
                    { quantity: "75cl", price: 55.0 },
                ],
                ...itemFlags,
            },
            {
                name_fr: "PIPPER HEIDSIECK BRUT",
                name_en: "PIPPER HEIDSIECK BRUT",
                description_fr: "",
                description_en: "",
                subContent: [{ quantity: "75cl", price: 75.0 }],
                ...itemFlags,
            },
        ],
    },

    digestifs: {
        title_fr: "DIGESTIFS",
        title_en: "DIGESTIVES",
        description_fr: "",
        description_en: "",
        content: [
            {
                name_fr: "MENTHE PASTILLE",
                name_en: "MINT PASTILLE",
                description_fr: "",
                description_en: "",
                subContent: [{ quantity: "4cl", price: 8.0 }],
                ...itemFlags,
            },
            {
                name_fr: "LIMONCELLO",
                name_en: "LIMONCELLO",
                description_fr: "",
                description_en: "",
                subContent: [{ quantity: "4cl", price: 9.0 }],
                ...itemFlags,
            },
            {
                name_fr: "CRÈME ALPINE",
                name_en: "ALPINE CREAM",
                description_fr: "Melon, Pistache, ...",
                description_en: "Melon, Pistachio, ...",
                subContent: [{ quantity: "4cl", price: 9.0 }],
                ...itemFlags,
            },
            {
                name_fr: "BAILEYS",
                name_en: "BAILEYS",
                description_fr: "",
                description_en: "",
                subContent: [{ quantity: "4cl", price: 9.0 }],
                ...itemFlags,
            },
            {
                name_fr: "GÉNÉPI",
                name_en: "GÉNÉPI",
                description_fr: "",
                description_en: "",
                subContent: [{ quantity: "4cl", price: 9.0 }],
                ...itemFlags,
            },
            {
                name_fr: "POIRE",
                name_en: "PEAR",
                description_fr: "",
                description_en: "",
                subContent: [{ quantity: "4cl", price: 10.0 }],
                ...itemFlags,
            },
            {
                name_fr: "PRUNE",
                name_en: "PLUM",
                description_fr: "",
                description_en: "",
                subContent: [{ quantity: "4cl", price: 10.0 }],
                ...itemFlags,
            },
            {
                name_fr: "CALVADOS",
                name_en: "CALVADOS",
                description_fr: "",
                description_en: "",
                subContent: [{ quantity: "4cl", price: 10.0 }],
                ...itemFlags,
            },
            {
                name_fr: "COGNAC HENNESSY",
                name_en: "COGNAC HENNESSY",
                description_fr: "",
                description_en: "",
                subContent: [{ quantity: "4cl", price: 12.0 }],
                ...itemFlags,
            },
            {
                name_fr: "ARMAGNAC",
                name_en: "ARMAGNAC",
                description_fr: "",
                description_en: "",
                subContent: [{ quantity: "4cl", price: 10.0 }],
                ...itemFlags,
            },
            {
                name_fr: "GRAPPA MARZADRO",
                name_en: "GRAPPA MARZADRO",
                description_fr: "",
                description_en: "",
                subContent: [{ quantity: "4cl", price: 11.0 }],
                ...itemFlags,
            },
            {
                name_fr: "SAMBUCA",
                name_en: "SAMBUCA",
                description_fr: "",
                description_en: "",
                subContent: [{ quantity: "4cl", price: 8.0 }],
                ...itemFlags,
            },
            {
                name_fr: "AMARETTO",
                name_en: "AMARETTO",
                description_fr: "",
                description_en: "",
                subContent: [{ quantity: "4cl", price: 9.0 }],
                ...itemFlags,
            },
            {
                name_fr: "MANZANA",
                name_en: "MANZANA",
                description_fr: "",
                description_en: "",
                subContent: [{ quantity: "4cl", price: 8.0 }],
                ...itemFlags,
            },
        ],
    },

    cafeteria: {
        title_fr: "BOISSONS CHAUDES",
        title_en: "HOT DRINKS",
        description_fr: "",
        description_en: "",
        content: [
            {
                name_fr: "ESPRESSO / DÉCA / ALLONGÉ",
                name_en: "ESPRESSO / DECAF / AMERICANO",
                description_fr: "",
                description_en: "",
                subContent: [{ quantity: null, price: 2.8 }],
                ...itemFlags,
            },
            {
                name_fr: "THÉ / INFUSIONS",
                name_en: "TEA / HERBAL INFUSIONS",
                description_fr: "",
                description_en: "",
                subContent: [{ quantity: null, price: 5.5 }],
                ...itemFlags,
            },
            {
                name_fr: "DOUBLE EXPRESSO",
                name_en: "DOUBLE ESPRESSO",
                description_fr: "",
                description_en: "",
                subContent: [{ quantity: null, price: 4.5 }],
                ...itemFlags,
            },
            {
                name_fr: "CHOCOLAT CHAUD",
                name_en: "HOT CHOCOLATE",
                description_fr: "",
                description_en: "",
                subContent: [{ quantity: null, price: 5.5 }],
                ...itemFlags,
            },
            {
                name_fr: "CAFÉ CRÈME",
                name_en: "CAFÉ CRÈME",
                description_fr: "",
                description_en: "",
                subContent: [{ quantity: null, price: 5.0 }],
                ...itemFlags,
            },
            {
                name_fr: "CAPPUCCINO",
                name_en: "CAPPUCCINO",
                description_fr: "",
                description_en: "",
                subContent: [{ quantity: null, price: 5.5 }],
                ...itemFlags,
            },
            {
                name_fr: "CAFÉ / CHOCOLAT VIENNOIS",
                name_en: "VIENNESE COFFEE / CHOCOLATE",
                description_fr: "",
                description_en: "",
                subContent: [{ quantity: null, price: 6.0 }],
                ...itemFlags,
            },
        ],
    },
};
